/**
 * Southeast Central Railway (SECR) Bilaspur Division - Project CCC
 * Centralized API Endpoint Registry
 */

export const ENDPOINTS = {
  // System Metrics & Dashboard
  DASHBOARD_STATS: '/GetDashboardStats',

  // Running Staff & Crew Contacts
  CONTACTS: {
    GET_ALL: '/GetContacts',
    GET_PROFILE: (id) => `/GetContactProfile/${id}`,
    CREATE: '/AddNewContact',
    UPDATE: (id) => `/EditContactProfile/${id}`,
    DELETE: (id) => `/DeleteContact/${id}`,
  },

  // Authentication & Credentials
  AUTH: {
    ADMIN_LOGIN: '/Login',
    ADMIN_REGISTER: '/Register',
    STAFF_LOGIN: '/StaffLogin',
    STAFF_REGISTER: '/StaffRegister',
  },

  // Computer-Based Training (CBT) Assessment
  QUIZ: {
    GET_QUESTIONS: '/GetQuizQuestions',
    ADD_QUESTION: '/AddNewQuizQuestion',
    UPDATE_QUESTION: (id) => `/UpdateQuizQuestion/${id}`,
    DELETE_QUESTION: (id) => `/DeleteQuizQuestion/${id}`,
    START: '/StartQuiz',
    SUBMIT: '/SubmitQuiz',
    ALL_SUBMISSIONS: '/GetAllQuizSubmissions',
    CANDIDATE_SUBMISSIONS: (name, email) =>
      `/GetCandidateSubmissions?name=${encodeURIComponent(name || '')}&email=${encodeURIComponent(email || '')}`,
  },

  // Digital Rule Books & Circulars
  BOOKS: {
    GET_ALL: '/GetBooks',
    CREATE: '/AddNewBook',
    DELETE: (id) => `/DeleteBook/${id}`,
    GET_CATEGORIES: '/GetCategory',
    CREATE_CATEGORY: '/AddNewCategory',
    DELETE_CATEGORY: (id) => `/DeleteCategory/${id}`,
  },

  // Safety Notices & Bulletins
  NOTICES: {
    GET_ALL: '/GetNotice',
    CREATE: '/AddNewNotice',
    DELETE: (id) => `/DeleteNotice/${id}`,
    GET_CATEGORIES: '/GetNoticeCategory',
    CREATE_CATEGORY: '/AddNewNoticeCategory',
    DELETE_CATEGORY: (id) => `/DeleteNoticeCategory/${id}`,
  },

  // Training & Safety Videos
  VIDEOS: {
    GET_ALL: '/GetVideos',
    CREATE: '/AddNewVideo',
    DELETE: (id) => `/DeleteVideo/${id}`,
    GET_CATEGORIES: '/GetVideoCategory',
    CREATE_CATEGORY: '/AddNewVideoCategory',
    DELETE_CATEGORY: (id) => `/DeleteVideoCategory/${id}`,
  },

  // Operational Gallery Cards
  CARDS: {
    GET_ALL: '/GetCards',
    CREATE: '/AddNewCard',
    DELETE: (id) => `/DeleteCard/${id}`,
  },

  // Suggestions & Crew Feedback
  FEEDBACK: {
    GET_ALL: '/GetFeedback',
    CREATE: '/AddNewFeedback',
  },

  // Navigation Links & External Resources
  OTHER_DROPDOWN: {
    GET_ALL: '/GetOtherDropDown',
    CREATE: '/AddNewOtherDropDown',
    DELETE: (id) => `/DeleteOtherDropDown/${id}`,
  },

  // Push Notifications (FCM)
  FCM: {
    SAVE_TOKEN: '/save-fcm-token',
  },
};

export default ENDPOINTS;
